// Slick arrow navigation
function slickArrowNavigation() {
	$(".js-slick-next").on("click", function(e) {
		e.preventDefault();
		$(this)
			.closest("section")
			.find(".slick-initialized")
			.slick("slickNext");
	});
	$(".js-slick-prev").on("click", function(e) {
		e.preventDefault();
		$(this)
			.closest("section")
			.find(".slick-initialized")
			.slick("slickPrev");
	});
}

/**
 * Hero image slider
 */
function initHeroSlider() {
    if ($(".js-hero-slider").length) {
		$(".js-hero-slider").slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			autoplay: true,
            autoplaySpeed: 5000,
			speed: 800,
			dots: false,
            arrows: false,
            mobileFirst: true,
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        autoplay: false,
                    }
                }
            ]            
		});

        $('.js-hero-slider').on('beforeChange', function(event, slick, currentSlide, nextSlide) {
            setTimeout(() => {
                const slide = nextSlide + 1;
                
                document.querySelector('.hero__curent-slide').innerHTML = slide;
            }, 350);
        });

        const nextArrow = document.querySelector('.js-hero-next-slide-arrow');

        if ( nextArrow ) {
            nextArrow.addEventListener('click', (e) => {
                e.preventDefault();

                $('.js-hero-slider').slick('slickNext');
            });
        }
	}
}

/**
 * Product category slider
 */
function initProductCatSlider() {
    if ($(".js-product-cat-slider").length) {
		$(".js-product-cat-slider").slick({
            infinite: false,
			slidesToShow: 2,
            swipeToSlide: true,
            arrows: false,
            dots: false,
            cssEase: 'linear',
            mobileFirst: true,
            responsive: [
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 5,
                    }
                }
            ]
        });
	}

    /* $('.product-cat-slider__slider.show-slider-arrows .js-prev-slide-trigger').on('click', function() {
        const slider = $(this).siblings('.js-product-cat-slider');

        slider.slick('slickPrev');
    });
    $('.product-cat-slider__slider.show-slider-arrows .js-next-slide-trigger').on('click', function() {
        const slider = $(this).siblings('.js-product-cat-slider');

        slider.slick('slickNext');
    }); 

    $('.js-product-cat-slider').on('swipe', function(event, slick, direction){
        $('.c-card[data-slick-index="-1"]').addClass('active');
    });*/
}


/**
 * Image slider
 */
function initTextImgSlider() {
    if ( $('.js-img-slider').length ) {
		var i = 1; $('.js-img-slider').each(function() {
			$(this).addClass('js-img-slider-'+i);

            var currentSlideElem = $('.js-img-slider-'+i).parentsUntil('.text-img-slider').find('.text-img-slider__curent-slide');

			$('.js-img-slider-'+i).slick({
                slidesToShow: 2,
                slidesToScroll: 1,
                swipeToSlide: true,
                arrows: true,
                dots: false,
                variableWidth: true,
                responsive: [
                    {
                        breakpoint: 700,
                        settings: {
                            slidesToShow: 1,
                        }
                    }
                ]
			});

            $('.js-img-slider-'+i).on('beforeChange', function(event, slick, currentSlide, nextSlide) {
                const slide = nextSlide + 1;
                currentSlideElem.html(slide);
            }); 

			i++;
		});

        var nextArrow = $('.js-text-image-next-slide-arrow');

        if ( nextArrow ) {
            nextArrow.on('click', (e) => {
                nextArrow.parentsUntil('.text-img-slider').find('.slick-next').trigger('click');
            });
        }
	}
}


/**
 * Product Gallery Image slider
 */
function initProductGallerySlider() {
    if ( $('.woocommerce-product-gallery__wrapper--multiple-images').length ) {
        $('.js__product-gallery').slick({
            slidesToShow: 1,
            fade: true,
            arrows: false,
            dots: true,
            mobileFirst: true,
            responsive: [
                {
                    breakpoint: 575,
                      settings: {
                        dots: false,
                        swipe: false,
                        draggable: false
                    }
                }
            ]
        });
    }

    $('.woocommerce-product-gallery__thumbnails .woocommerce-product-gallery__thumbnail:not(.active) a').on('click', function(e) {
        e.preventDefault();

        $('.woocommerce-product-gallery__thumbnails').removeClass('woocommerce-product-gallery__thumbnails--no-interaction');

        const index = $(this).closest('.woocommerce-product-gallery__thumbnail').index();
        $('.js__product-gallery').slick('slickGoTo', index, false);

        $('.woocommerce-product-gallery__thumbnail').removeClass('active');
        $(this).closest('.woocommerce-product-gallery__thumbnail').addClass('active');
    });

    
    $('.js__variation-elem--pa_colour').on('click', function(e) {
        const variation = $(this).data('value');

        if ( $('.woocommerce-product-gallery__thumbnail[data-colour="'+variation+'"]').length ) {

            $('.woocommerce-product-gallery__thumbnails').removeClass('woocommerce-product-gallery__thumbnails--no-interaction');
    
            const index = $('.woocommerce-product-gallery__thumbnail[data-colour="'+variation+'"]').index();
            $('.js__product-gallery').slick('slickGoTo', index, false);
            
            $('.woocommerce-product-gallery__thumbnail').removeClass('active');
            $('.woocommerce-product-gallery__thumbnail[data-colour="'+variation+'"]').addClass('active');
        }
    });
}
